import { ChevronDown, ChevronUp, Rocket } from 'lucide-react';
import React, { useState } from 'react';
import CurrencyText from '../../../components/ui/labels/CurrencyText';
import useIsMobile from '../../../components/hooks/useIsMobile';

const DreamsTab = ({ currentDreams, completedDreams }) => {
  const [showCurrent, setShowCurrent] = useState(true);
  const [showCompleted, setShowCompleted] = useState(false);

  const handleToggleCurrent = () => {
    setShowCurrent(!showCurrent);
  };

  const handleToggleCompleted = () => {
    setShowCompleted(!showCompleted);
  };

  const isMobile = useIsMobile(1024);

  return (
    <div className="flex flex-col gap-5">
      <div className="flex justify-between cursor-pointer items-center" onClick={handleToggleCurrent}>
        <h2 className="text-lg text-blueDarker font-semibold">Objetivos atuais ({currentDreams.length})</h2>
        {showCurrent ? (
          <ChevronUp className="text-blueDarker rotate-180 cursor-pointer" size={20} strokeWidth={1.5} />
        ) : (
          <ChevronDown className="text-blueDarker cursor-pointer" size={20} strokeWidth={1.5} />
        )}
      </div>
      {showCurrent && (
        <div className="flex flex-col gap-5">
          {currentDreams.length === 0 ? (
            <></>
          ) : (
            currentDreams.map((dream) => (
              <div
                key={dream.id}
                className={`flex rounded-custom20 p-4 bg-blueLight ${
                  isMobile ? 'flex-col' : 'flex-row justify-between items-center'
                }`}
              >
                <div className="flex items-center gap-3">
                  <span className="rounded-full bg-tealMedium text-white w-12 h-12 flex items-center justify-center">
                    <Rocket className="text-white inline-block" size={24} strokeWidth={1.5} />
                  </span>
                  <div>
                    <h3 className="text-lg font-semibold text-blueDarker">{dream.name}</h3>
                    <p className="text-sm text-blueHighlight">Faltam {dream.remainingMonths} meses!</p>
                  </div>
                </div>
                <div className={`flex flex-col ${isMobile ? 'items-center text-center' : 'text-right items-end'}`}>
                  <CurrencyText value={dream.dreamValue} size="xSmall" className="" color="blueDarker" />
                  <p className="text-sm text-blueDarker">{dream.targetDate}</p>
                </div>
              </div>
            ))
          )}
        </div>
      )}
      <div className="flex justify-between cursor-pointer items-center" onClick={handleToggleCompleted}>
        <h2 className="text-lg text-blueDarker font-semibold">Objetivos concluídos ({completedDreams.length})</h2>
        {showCompleted ? (
          <ChevronUp className="text-blueDarker rotate-180 cursor-pointer" size={20} strokeWidth={1.5} />
        ) : (
          <ChevronDown className="text-blueDarker cursor-pointer" size={20} strokeWidth={1.5} />
        )}
      </div>
      {showCompleted && (
        <div className="flex flex-col gap-5">
          {completedDreams.length === 0 ? (
            <></>
          ) : (
            completedDreams.map((dream) => (
              <div
                key={dream.id}
                className={`flex rounded-custom20 p-4 bg-blueLight ${
                  isMobile ? 'flex-col' : 'flex-row justify-between items-center'
                }`}
              >
                <div className="flex items-center gap-3">
                  <span className="rounded-full bg-tealMedium text-white w-12 h-12 flex items-center justify-center">
                    <Rocket className="text-white inline-block" size={24} strokeWidth={1.5} />
                  </span>
                  <div>
                    <h3 className="text-lg font-semibold text-blueDarker">{dream.name}</h3>
                    <p className="text-sm text-blueHighlight">Objetivo concluído!</p>
                  </div>
                </div>
                <div className="text-right flex flex-col items-end">
                  <CurrencyText value={dream.dreamValue} size="xSmall" className="" color="blueDarker" />
                  <p className="text-sm text-blueDarker">{dream.targetDate}</p>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default DreamsTab;
